//export const API_ServerAddress: string = 'http://localhost:5000';

export const API_ServerAddress: string = 'https://api.novinmedco.com';
export const CrmAPI: string = 'https://crm.novinmedco.com';

//export const CrmAPI: string = 'http://localhost:5001';